import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { deleteWorkOrderTemplate } from '#/graphql/mutations';
import { GET_WORK_ORDER_PROPS_COUNTS } from '#/modules/workOrder/hooks/useWorkOrderPropsCountsQuery';

const q = gql(deleteWorkOrderTemplate);

const useWOTemplateDelete = () => {
  const [mutation, result] = useMutation(q);

  const deleteWOTemplate = useCallback(
    (woTemplateId: string) => {
      return mutation({
        variables: {
          id: woTemplateId,
        },
        refetchQueries: [{ query: GET_WORK_ORDER_PROPS_COUNTS }],
        awaitRefetchQueries: true,
      });
    },
    [mutation],
  );

  return { deleteWOTemplate, result };
};

export default useWOTemplateDelete;
